import { render, staticRenderFns } from "./SlidesPanel.vue?vue&type=template&id=4163dc9c&scoped=true&"
import script from "./SlidesPanel.vue?vue&type=script&lang=js&"
export * from "./SlidesPanel.vue?vue&type=script&lang=js&"
import style0 from "./SlidesPanel.vue?vue&type=style&index=0&id=4163dc9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4163dc9c",
  null
  
)

export default component.exports